import React from 'react';

export default function CustomNavB({ stan, margines, marginesBok, hamburgerStan }) {

    return (
        <div
            id="m-nav-bottom"
            className={`${hamburgerStan ? 'hidden' : stan}`}
            style={{ marginTop: margines }} // Dodaj wartość marginesu jako wartość dla stylu marginTop
        >
            <div className='flex justify-center items-center w-full h-full'>
            <ul>
                <li data-menuanchor="start" className='active'> {/* bez klasy active, menu nie dziala dobrze */}
                    <a className=' navbar-hov' href='#start'>
                        <span></span>
                    </a>
                </li>
                <li data-menuanchor="projects" className='active'> {/* bez klasy active, menu nie dziala dobrze */}
                <a className=' navbar-hov' href='#projects'>
                    <span></span>
                </a>
            </li>
                <li data-menuanchor="about">
                    <a className=' navbar-hov' href='#about'>
                        <span></span>
                    </a>
                </li>
                <li data-menuanchor="contact">
                    <a className=' navbar-hov' href='#contact'>
                        <span></span>
                    </a>
                </li>
            </ul>
            </div>
        </div>
    )

}